import { z } from 'zod';

export const JsonPrimitiveZod = z.union([z.string(), z.number(), z.boolean(), z.null()]);

export const JsonValueZod: z.ZodType<unknown> = z.lazy(() => z.union([JsonPrimitiveZod, z.array(JsonValueZod), z.record(z.string(), JsonValueZod)]));

export type JsonPrimitive = z.infer<typeof JsonPrimitiveZod>;
export type JsonValue = z.infer<typeof JsonValueZod>;
